<template>
  <div v-if="data" ref="echars" class="echars-class">
  </div>
</template>

<script>
export default {
  name: "age",
  data: () => ({
    chats: undefined,
    data: undefined
  }),
  methods: {
    init(data) {
      this.data = data

      let _data = []

      this.data.forEach(item => {
        _data.push({
          name: item.ageRange,
          percent: item.percent,
          value: item.people
        })
      })

      let option = {
        grid: {
          // right: '0',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: _data.map(item => item.name),
          axisLabel: {interval: 0, rotate: 30}
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            barMaxWidth: '50%',
            label: {
              show: true,
              position: 'top',
              formatter(params) {
                return `${params.data.percent}%`
              }
            },
            data: _data,
            type: 'bar',
          }
        ]
      };
      this.$nextTick(() => {
        this.chats = this.$echarts.init(this.$refs.echars, 'vintage', {renderer: 'canvas'})
        this.chats.setOption(option);
        this.chats.resize();
      })
    },
    resize() {
      this.$nextTick(() => {
        if (this.chats) {
          this.chats.resize();
        }
      })
    }
  }
}
</script>

<style scoped>
.echars-class {
  width: 100%;
  height: 100%;
}
</style>
